export default "__VITE_ASSET__BUhJdH6x__"